import {
    getData,
    postData,
    patchData,
    deleteData
} from './Services'

export const getOrderCacheLista = async () => {
  const res = await getData('/ordercache');
  return res
} 

export const getOrderCachePanel = async (searchCli, searchSel, page, perPage) => {
  let queryParams = [];
  if (searchCli) {
    queryParams.push(`cli_id=${encodeURIComponent(searchCli)}`);
  }
  if (searchSel) {
    queryParams.push(`sel_id=${encodeURIComponent(searchSel)}`);
  }
  if (page) {
    queryParams.push(`page=${encodeURIComponent(page)}`);
  }
  if (perPage) {
    queryParams.push(`perPage=${encodeURIComponent(perPage)}`);
  }
  const queryString = queryParams.length > 0 ? `?${queryParams.join('&')}` : '';

  return await getData("/ordercache/busquedaOrderCache_filtros", queryString);
}


export const getOrderCacheById = async (id) => {
  const res = await getData(`/ordercache/${id}`)
  return res
}

export const postOrderCache = async (body) => {
  const res = await postData('/ordercache', body)
  return res
}

export const patchOrderCache = async (id, body) => {
  const res = await patchData(`/ordercache/${id}`, body)
  return res
}

export const deleteOrderCache = async (id) => {
  const res = await deleteData(`/ordercache/${id}`)
  return res
}